import { WhereAreYouScreen } from '@/screens/name-screen/WhereAreYouScreen'

export default function () {
  return <WhereAreYouScreen />
}
